const PORTFOLIO_IMAGES = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/71rhp46w_FOTO%2016.png",
    alt: "Chá de bebê Oh Baby - tema ursinhos dourado",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/ihwe8uz9_FOTO%2017.png",
    alt: "Chá revelação - Menino ou Menina",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_celebration-hub-359/artifacts/r9jsb6m3_FOTO%2018.png",
    alt: "Chá de bebê - tema lua e estrelas dourado",
  },
];

export default function Portfolio() {
  return (
    <section data-testid="portfolio-section" className="py-24 bg-[#E4DCCC]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#E4077B] text-xs tracking-[0.25em] uppercase font-medium">Sonhos Realizados</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Chá Revelação
          </h2>
          <div className="w-12 h-0.5 bg-[#E4077B] mx-auto mt-4" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-[#555555] leading-relaxed text-base">
            Cada chá revelação é um capítulo cheio de emoção e alegria! Aqui, decoramos com carinho o cenário que será palco desses instantes únicos, onde a surpresa, o amor e a curiosidade que envolvem o sexo do bebê serão revelados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PORTFOLIO_IMAGES.map((img, i) => (
            <div
              key={i}
              className="overflow-hidden rounded-3xl hover-lift"
              data-testid={`portfolio-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-72 md:h-96 object-cover transition-transform duration-500 hover:scale-105"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
